<template>
  <div class="room dehumidifier-room" v-loading="loadingData">
    <div class="dehumidifier-main">
      <div class="main-column-multi-line">
        <div class="column-line">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop1" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop11" :series="switchDataTop11" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop12" :series="switchDataTop12" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop13" :series="switchDataTop13" />
          <SwitchStatus class="switch-item" :title="switchTitleTop14" :series="switchDataTop14" />
        </div>
        <div class="column-line">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleDown1" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleDown100" :series="switchDataDown100" />
          <SwitchStatus class="switch-item" :title="switchTitleDown101" :series="switchDataDown101" />
          <SwitchStatus class="switch-item" :title="switchTitleDown11" :series="switchDataDown11" />
          <!-- <SwitchStatus class="switch-item" :title="switchTitleDown12" :series="switchDataDown12" /> -->
          <SwitchStatus class="switch-item" :title="switchTitleDown13" :series="switchDataDown13" />
          <SwitchStatus class="switch-item" :title="switchTitleDown14" :series="switchDataDown14" />
          <SwitchStatus class="switch-item" :title="switchTitleDown15" :series="switchDataDown15" />
          <SwitchStatus class="switch-item" :title="switchTitleDown16" :series="switchDataDown16" />
          <SwitchStatus class="switch-item" :title="switchTitleDown17" :series="switchDataDown17" />
        </div>
      </div>
      <div class="main-column">
        <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop2" :bold="true" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop21" :series="switchDataTop21" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop22" :series="switchDataTop22" />
        <SwitchStatus class="switch-item" :title="switchTitleTop23" :series="switchDataTop23" />
        <SwitchStatus class="switch-item" :title="switchTitleTop24" :series="switchDataTop24" />
        <SwitchStatus class="switch-item" :title="switchTitleTop25" :series="switchDataTop25" />
        <SwitchStatus class="switch-item" :title="switchTitleTop26" :series="switchDataTop26" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop27" :series="switchDataTop27" />
      </div>
      <div class="main-column">
        <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop3" :bold="true" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop31" :series="switchDataTop31" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop32" :series="switchDataTop32" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop33" :series="switchDataTop33" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop34" :series="switchDataTop34" />
        <SwitchStatus class="switch-item" :title="switchTitleTop36" :series="switchDataTop36" />
        <SwitchStatus class="switch-item" :title="switchTitleTop37" :series="switchDataTop37" />
        <SwitchStatus class="switch-item" :title="switchTitleTop35" :series="switchDataTop35" />
        <SwitchStatus class="switch-item" :title="switchTitleTop38" :series="switchDataTop38" />
        <SwitchStatus class="switch-item" :title="switchTitleTop39" :series="switchDataTop39" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop310" :series="switchDataTop310" />
      </div>
      <div class="main-column">
        <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop4" :bold="true" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop41" :series="switchDataTop41" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop42" :series="switchDataTop42" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop43" :series="switchDataTop43" />
        <SwitchStatus class="switch-item" :title="switchTitleTop44" :series="switchDataTop44" />
        <SwitchStatus class="switch-item" :title="switchTitleTop45" :series="switchDataTop45" />
        <SwitchStatus class="switch-item" :title="switchTitleTop46" :series="switchDataTop46" />
        <SwitchStatus class="switch-item" :title="switchTitleTop47" :series="switchDataTop47" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop48" :series="switchDataTop48" />
      </div>
      <div class="main-column">
        <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop5" :bold="true" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop51" :series="switchDataTop51" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop52" :series="switchDataTop52" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop53" :series="switchDataTop53" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop54" :series="switchDataTop54" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop55" :series="switchDataTop55" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop56" :series="switchDataTop56" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop57" :series="switchDataTop57" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop58" :series="switchDataTop58" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop58B" :series="switchDataTop58B" />
        <SwitchStatus class="switch-item" :title="switchTitleTop510" :series="switchDataTop510" />
        <SwitchStatus class="switch-item" :title="switchTitleTop59" :series="switchDataTop59" />
        <SwitchStatus class="switch-item" :title="switchTitleTop511" :series="switchDataTop511" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop512" :series="switchDataTop512" />
      </div>
      <div class="main-column-small">
        <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop6" :bold="true" />
      </div>
      <div class="main-column-large">
        <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop7" :bold="true" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop71" :series="switchDataTop71" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop72" :series="switchDataTop72" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop73" :series="switchDataTop73" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop74" :series="switchDataTop74" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop75" :series="switchDataTop75" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop76" :series="switchDataTop76" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop77" :series="switchDataTop77" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop78" :series="switchDataTop78" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop79" :series="switchDataTop79" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop710" :series="switchDataTop710" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop711" :series="switchDataTop711" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop712" :series="switchDataTop712" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop713" :series="switchDataTop713" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop714" :series="switchDataTop714" />
        <SwitchStatusValue class="switch-item" :title="switchTitleTop715" :series="switchDataTop715" />
      </div>
    </div>

    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
  </div>
</template>
    
    <script>
import configJson from "./config/station.json";

export default {
  name: "tower",
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationId: "",
      stationName: "",
      stationIndex: "",
      stationVentNameFix: "",

      columnTitleTop1: "前置过滤段",
      columnTitleTop2: "前置表冷段(备)",
      // columnTitleTop3: "空气浓缩段",
      columnTitleTop4: "后置表冷段(备)",
      columnTitleTop5: "送风段(备)",
      columnTitleTop6: "后置过滤段(备)",
      columnTitleTop7: "储气罐(备)",
      columnTitleDown1: "控制箱",

      switchDataTop11: null,
      switchDataTop12: null,
      switchDataTop13: null,
      switchDataTop14: null,

      switchDataTop21: null,
      switchDataTop22: null,
      switchDataTop23: null,
      switchDataTop24: null,
      switchDataTop25: null,
      switchDataTop26: null,
      switchDataTop27: null,

      switchDataTop31: null,
      switchDataTop32: null,
      switchDataTop33: null,
      switchDataTop34: null,
      switchDataTop35: null,
      switchDataTop36: null,
      switchDataTop37: null,
      switchDataTop38: null,
      switchDataTop39: null,
      switchDataTop310: null,

      switchDataTop41: null,
      switchDataTop42: null,
      switchDataTop43: null,
      switchDataTop44: null,
      switchDataTop45: null,
      switchDataTop46: null,
      switchDataTop47: null,
      switchDataTop48: null,

      switchDataTop51: null,
      switchDataTop52: null,
      switchDataTop53: null,
      switchDataTop54: null,
      switchDataTop55: null,
      switchDataTop56: null,
      switchDataTop57: null,
      switchDataTop58: null,
      switchDataTop58B: null,
      switchDataTop59: null,
      switchDataTop510: null,
      switchDataTop511: null,
      switchDataTop512: null,

      switchDataTop71: null,
      switchDataTop72: null,
      switchDataTop73: null,
      switchDataTop74: null,
      switchDataTop75: null,
      switchDataTop76: null,
      switchDataTop77: null,
      switchDataTop78: null,
      switchDataTop79: null,
      switchDataTop710: null,
      switchDataTop711: null,
      switchDataTop712: null,
      switchDataTop713: null,
      switchDataTop714: null,
      switchDataTop715: null,

      switchDataDown11: null,
      switchDataDown12: null,
      switchDataDown13: null,
      switchDataDown14: null,
      switchDataDown15: null,
      switchDataDown16: null,
      switchDataDown17: null,

      warningFlagLeft: "",
      warningFlagRight: "",
      deviceList: [],
      singlePieHistogramWrapData1: null,
      singlePieHistogramWrapData2: null,
      singlePieHistogramWrapData3: null,
      singlePieHistogramWrapData4: null,
      warningFlag1: "",
      warningFlag2: "",
      warningFlag3: "",
      warningFlag4: "",
      humidityLineData: null,
      humidityBarData: null,

      runningTimeDataLeft: null,
      runningTimeDataRight: null,
    };
  },
  computed: {
    columnTitleTop3: function () {
      return this.stationIndex + "站备用 空气浓缩段";
    },
    switchTitleTop11: function () {
      return "新风温度";
    },
    switchTitleTop12: function () {
      return "新风湿度";
    },
    switchTitleTop13: function () {
      return "新风压差";
    },
    switchTitleTop14: function () {
      return "初效压差";
    },

    switchTitleTop21: function () {
      return "前表温度";
    },
    switchTitleTop22: function () {
      return "前表温度设定";
    },
    switchTitleTop23: function () {
      return "前表运行状态";
    },
    switchTitleTop24: function () {
      return "前表电磁阀状态";
    },
    switchTitleTop25: function () {
      return "1#前表高压保护";
    },
    switchTitleTop26: function () {
      return "1#前表低压保护";
    },
    switchTitleTop27: function () {
      return "运行";
    },

    switchTitleTop31: function () {
      return "再生加热温度";
    },
    switchTitleTop32: function () {
      return "再生排风温度";
    },
    switchTitleTop33: function () {
      return "再生加热温度设定";
    },
    switchTitleTop34: function () {
      return "排风风速";
    },
    switchTitleTop35: function () {
      return "再生风机压差";
    },
    switchTitleTop36: function () {
      return "再生加热运行";
    },
    switchTitleTop37: function () {
      return "再生转轮运行";
    },
    switchTitleTop38: function () {
      return "再生加热保护";
    },
    switchTitleTop39: function () {
      return "减速机过载";
    },
    switchTitleTop310: function () {
      return "运行";
    },

    switchTitleTop41: function () {
      return "后表温度";
    },
    switchTitleTop42: function () {
      return "温度设定";
    },
    switchTitleTop43: function () {
      return "湿度设定";
    },
    switchTitleTop44: function () {
      return "后表运行状态";
    },
    switchTitleTop45: function () {
      return "后表电磁阀状态";
    },
    switchTitleTop46: function () {
      return "1#后表高压保护";
    },
    switchTitleTop47: function () {
      return "1#后表低压保护";
    },
    switchTitleTop48: function () {
      return "运行";
    },

    switchTitleTop51: function () {
      return "送风温度";
    },
    switchTitleTop52: function () {
      return "送风湿度";
    },
    switchTitleTop53: function () {
      return "送风露点温度";
    },
    switchTitleTop54: function () {
      return "送风高效压力";
    },
    switchTitleTop55: function () {
      return "高压出口温度";
    },
    switchTitleTop56: function () {
      return "高压出口湿度";
    },
    switchTitleTop57: function () {
      return "高压出口压力";
    },
    switchTitleTop58: function () {
      return "高压出口风速";
    },
    switchTitleTop58B: function () {
      return "高压出口风量";
    },
    switchTitleTop59: function () {
      return "主风机压差";
    },
    switchTitleTop510: function () {
      return "主风机运行状态";
    },
    switchTitleTop511: function () {
      return "主风机过载";
    },
    switchTitleTop512: function () {
      return "运行";
    },

    switchTitleTop71: function () {
      return "储气罐温度";
    },
    switchTitleTop72: function () {
      return "储气罐湿度";
    },
    switchTitleTop73: function () {
      return "储气罐压力";
    },
    switchTitleTop74: function () {
      return "Z1"+ this.stationVentNameFix + "出口";
    },
    switchTitleTop75: function () {
      return "Z1"+ this.stationVentNameFix + "出口";
    },
    switchTitleTop76: function () {
      return "N1"+ this.stationVentNameFix + "出口";
    },
    switchTitleTop77: function () {
      return "N1"+ this.stationVentNameFix + "出口";
    },
    switchTitleTop78: function () {
      return "Z2"+ this.stationVentNameFix + "出口";
    },
    switchTitleTop79: function () {
      return "Z2"+ this.stationVentNameFix + "出口";
    },
    switchTitleTop710: function () {
      return "N2"+ this.stationVentNameFix + "出口";
    },
    switchTitleTop711: function () {
      return "N2"+ this.stationVentNameFix + "出口";
    },
    switchTitleTop712: function () {
      return "Z3"+ this.stationVentNameFix + "出口";
    },
    switchTitleTop713: function () {
      return "Z3"+ this.stationVentNameFix + "出口";
    },
    switchTitleTop714: function () {
      return "N3"+ this.stationVentNameFix + "出口";
    },
    switchTitleTop715: function () {
      return "N3"+ this.stationVentNameFix + "出口";
    },

    switchTitleDown100: function () {
      return "机组运行状态";
    },
    switchTitleDown101: function () {
      return "除湿机状态";
    },
    switchTitleDown11: function () {
      return "开关机";
    },
    switchTitleDown12: function () {
      return "关机";
    },
    switchTitleDown13: function () {
      return "通风状态";
    },
    switchTitleDown14: function () {
      return "报警信号灯";
    },
    switchTitleDown15: function () {
      return "电源故障";
    },
    switchTitleDown16: function () {
      return "急停报警";
    },
    switchTitleDown17: function () {
      return "报警复位";
    },

    runningTimeTitleRight: function () {
      return "风机运行时间";
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    resetData() {
      this.warningFlagLeft = "";
      this.warningFlagRight = "";
      this.warningFlag1 = "";
      this.warningFlag2 = "";
      this.warningFlag3 = "";
      this.warningFlag4 = "";
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      const routerName = routerPath[3].toLowerCase();
      this.deviceList = configJson[routerName].deviceList;
      this.stationName = configJson[routerName].stationName;
      this.stationId = configJson[routerName].stationId;
      this.stationIndex = configJson[routerName].stationIndex;   
      this.stationVentNameFix = configJson[routerName].stationVentNameFix;
    },
    findDeviceId_actual(deviceName) {
      //temporary. input column is valid for empty backup page.
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    findDeviceId(deviceName) {
      //for backup pages
      return "GUID";

      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    getStatisticsData(deviceId) {
      return this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_HOUR&insertBlankData=true");
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      // this.getLineChartData();

      this.getCurrentData(this.stationId).then((res) => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);

        res.data["GUID"] = {
          dataId: null,
          deviceId: "GUID",
          value: null,
          createdDate: "0001-01-01T00:00:00",
          dataDate: "0001-01-01T00:00:00",
          dataType: "VALUE",
          errorLevel: "Warning",
        };

        const currentData = res.data;

        const switchIdTop11 = this.findDeviceId_actual(this.switchTitleTop11);
        const switchIdTop12 = this.findDeviceId_actual(this.switchTitleTop12);
        const switchIdTop13 = this.findDeviceId_actual(this.switchTitleTop13);
        const switchIdTop14 = this.findDeviceId_actual(this.switchTitleTop14);
        this.switchDataTop11 = {
          data: currentData[switchIdTop11].value,
          isError: currentData[switchIdTop11].errorLevel,
          unit: "℃",
        };
        this.switchDataTop12 = {
          data: currentData[switchIdTop12].value,
          isError: currentData[switchIdTop12].errorLevel,
          unit: "%",
        };
        this.switchDataTop13 = {
          data: currentData[switchIdTop13].value,
          isError: currentData[switchIdTop13].errorLevel,
          unit: "Pa",
        };
        this.switchDataTop14 = {
          data: currentData[switchIdTop14].value,
          isError: currentData[switchIdTop14].errorLevel,
          isZh: true,
        };

        const switchIdTop21 = this.findDeviceId(this.switchTitleTop21);
        const switchIdTop22 = this.findDeviceId(this.switchTitleTop22);
        const switchIdTop23 = this.findDeviceId(this.switchTitleTop23);
        const switchIdTop24 = this.findDeviceId(this.switchTitleTop24.replace("状态", ""));
        const switchIdTop25 = this.findDeviceId(this.switchTitleTop25);
        const switchIdTop26 = this.findDeviceId(this.switchTitleTop26);
        const switchIdTop27 = this.findDeviceId("前表段" + this.switchTitleTop27 + "时间");
        this.switchDataTop21 = {
          data: currentData[switchIdTop21].value,
          isError: currentData[switchIdTop21].errorLevel,
          unit: "℃",
        };
        this.switchDataTop22 = {
          data: currentData[switchIdTop22].value,
          isError: currentData[switchIdTop22].errorLevel,
          unit: "℃",
        };
        this.switchDataTop23 = {
          data: currentData[switchIdTop23].value,
          isError: currentData[switchIdTop23].errorLevel,
        };
        this.switchDataTop24 = {
          data: currentData[switchIdTop24].value,
          isError: currentData[switchIdTop24].errorLevel,
        };
        this.switchDataTop25 = {
          data: currentData[switchIdTop25].value,
          isError: currentData[switchIdTop25].errorLevel,
          isZh: true,
        };
        this.switchDataTop26 = {
          data: currentData[switchIdTop26].value,
          isError: currentData[switchIdTop26].errorLevel,
          isZh: true,
        };
        this.switchDataTop27 = {
          data: currentData[switchIdTop27].value,
          isError: currentData[switchIdTop27].errorLevel,
          isRunningTime: true,
        };

        const switchIdTop31 = this.findDeviceId(this.switchTitleTop31);
        const switchIdTop32 = this.findDeviceId(this.switchTitleTop32);
        const switchIdTop33 = this.findDeviceId(this.switchTitleTop33);
        const switchIdTop34 = this.findDeviceId(this.switchTitleTop34);
        const switchIdTop35 = this.findDeviceId(this.switchTitleTop35);
        const switchIdTop36 = this.findDeviceId(this.switchTitleTop36.replace("运行", ""));
        const switchIdTop37 = this.findDeviceId(this.switchTitleTop37.replace("运行", ""));
        const switchIdTop38 = this.findDeviceId(this.switchTitleTop38);
        const switchIdTop39 = this.findDeviceId(this.switchTitleTop39);
        const switchIdTop310 = this.findDeviceId("除湿段" + this.switchTitleTop310 + "时间");
        this.switchDataTop31 = {
          data: currentData[switchIdTop31].value,
          isError: currentData[switchIdTop31].errorLevel,
          unit: "℃",
        };
        this.switchDataTop32 = {
          data: currentData[switchIdTop32].value,
          isError: currentData[switchIdTop32].errorLevel,
          unit: "℃",
        };
        this.switchDataTop33 = {
          data: currentData[switchIdTop33].value,
          isError: currentData[switchIdTop33].errorLevel,
          unit: "℃",
        };
        this.switchDataTop34 = {
          data: currentData[switchIdTop34].value,
          isError: currentData[switchIdTop34].errorLevel,
          unit: "m/s",
        };
        this.switchDataTop35 = {
          data: currentData[switchIdTop35].value,
          isError: currentData[switchIdTop35].errorLevel,
          isZh: true,
        };
        this.switchDataTop36 = {
          data: currentData[switchIdTop36].value,
          isError: currentData[switchIdTop36].errorLevel,
        };
        this.switchDataTop37 = {
          data: currentData[switchIdTop37].value,
          isError: currentData[switchIdTop37].errorLevel,
        };
        this.switchDataTop38 = {
          data: currentData[switchIdTop38].value,
          isError: currentData[switchIdTop38].errorLevel,
          isZh: true,
        };
        this.switchDataTop39 = {
          data: currentData[switchIdTop39].value,
          isError: currentData[switchIdTop39].errorLevel,
          isZh: true,
        };
        this.switchDataTop310 = {
          data: currentData[switchIdTop310].value,
          isError: currentData[switchIdTop310].errorLevel,
          isRunningTime: true,
        };

        const switchIdTop41 = this.findDeviceId(this.switchTitleTop41);
        const switchIdTop42 = this.findDeviceId(this.switchTitleTop42);
        const switchIdTop43 = this.findDeviceId(this.switchTitleTop43);
        const switchIdTop44 = this.findDeviceId(this.switchTitleTop44);
        const switchIdTop45 = this.findDeviceId(this.switchTitleTop45.replace("状态", ""));
        const switchIdTop46 = this.findDeviceId(this.switchTitleTop46);
        const switchIdTop47 = this.findDeviceId(this.switchTitleTop47);
        const switchIdTop48 = this.findDeviceId("后表段" + this.switchTitleTop48 + "时间");
        this.switchDataTop41 = {
          data: currentData[switchIdTop41].value,
          isError: currentData[switchIdTop41].errorLevel,
          unit: "℃",
        };
        this.switchDataTop42 = {
          data: currentData[switchIdTop42].value,
          isError: currentData[switchIdTop42].errorLevel,
          unit: "℃",
        };
        this.switchDataTop43 = {
          data: currentData[switchIdTop43].value,
          isError: currentData[switchIdTop43].errorLevel,
          unit: "%",
        };
        this.switchDataTop44 = {
          data: currentData[switchIdTop44].value,
          isError: currentData[switchIdTop44].errorLevel,
        };
        this.switchDataTop45 = {
          data: currentData[switchIdTop45].value,
          isError: currentData[switchIdTop45].errorLevel,
        };
        this.switchDataTop46 = {
          data: currentData[switchIdTop46].value,
          isError: currentData[switchIdTop46].errorLevel,
          isZh: true,
        };
        this.switchDataTop47 = {
          data: currentData[switchIdTop47].value,
          isError: currentData[switchIdTop47].errorLevel,
          isZh: true,
        };
        this.switchDataTop48 = {
          data: currentData[switchIdTop48].value,
          isError: currentData[switchIdTop48].errorLevel,
          isRunningTime: true,
        };

        const switchIdTop51 = this.findDeviceId(this.switchTitleTop51);
        const switchIdTop52 = this.findDeviceId(this.switchTitleTop52);
        const switchIdTop53 = this.findDeviceId(this.switchTitleTop53);
        const switchIdTop54 = this.findDeviceId(this.switchTitleTop54);
        const switchIdTop55 = this.findDeviceId(this.switchTitleTop55);
        const switchIdTop56 = this.findDeviceId(this.switchTitleTop56.replace("运行", ""));
        const switchIdTop57 = this.findDeviceId(this.switchTitleTop57.replace("运行", ""));
        const switchIdTop58 = this.findDeviceId(this.switchTitleTop58);
        const switchIdTop58b = this.findDeviceId(this.switchTitleTop58B);
        const switchIdTop59 = this.findDeviceId(this.switchTitleTop59);
        const switchIdTop510 = this.findDeviceId(this.switchTitleTop510);
        const switchIdTop511 = this.findDeviceId(this.switchTitleTop511);
        const switchIdTop512 = this.findDeviceId("送风段" + this.switchTitleTop512 + "时间");
        this.switchDataTop51 = {
          data: currentData[switchIdTop51].value,
          isError: currentData[switchIdTop51].errorLevel,
          unit: "℃",
        };
        this.switchDataTop52 = {
          data: currentData[switchIdTop52].value,
          isError: currentData[switchIdTop52].errorLevel,
          unit: "%",
        };
        this.switchDataTop53 = {
          data: currentData[switchIdTop53].value,
          isError: currentData[switchIdTop53].errorLevel,
          unit: "℃",
        };
        this.switchDataTop54 = {
          data: currentData[switchIdTop54].value,
          isError: currentData[switchIdTop54].errorLevel,
          unit: "KPa",
        };
        this.switchDataTop55 = {
          data: currentData[switchIdTop55].value,
          isError: currentData[switchIdTop55].errorLevel,
          unit: "℃",
        };
        this.switchDataTop56 = {
          data: currentData[switchIdTop56].value,
          isError: currentData[switchIdTop56].errorLevel,
          unit: "%",
        };
        this.switchDataTop57 = {
          data: currentData[switchIdTop57].value,
          isError: currentData[switchIdTop57].errorLevel,
          unit: "KPa",
        };
        this.switchDataTop58 = {
          data: currentData[switchIdTop58].value,
          isError: currentData[switchIdTop58].errorLevel,
          unit: "m/s",
        };
        this.switchDataTop58B = {
          data: currentData[switchIdTop58b].value,
          isError: currentData[switchIdTop58b].errorLevel,
          unit: "m³/h",
        };
        this.switchDataTop59 = {
          data: currentData[switchIdTop59].value,
          isError: currentData[switchIdTop59].errorLevel,
          isZh: true,
        };
        this.switchDataTop510 = {
          data: currentData[switchIdTop510].value,
          isError: currentData[switchIdTop510].errorLevel,
        };
        this.switchDataTop511 = {
          data: currentData[switchIdTop511].value,
          isError: currentData[switchIdTop511].errorLevel,
          isZh: true,
        };
        this.switchDataTop512 = {
          data: currentData[switchIdTop512].value,
          isError: currentData[switchIdTop512].errorLevel,
          isRunningTime: true,
        };

        const switchIdTop71 = this.findDeviceId(this.switchTitleTop71);
        const switchIdTop72 = this.findDeviceId(this.switchTitleTop72);
        const switchIdTop73 = this.findDeviceId(this.switchTitleTop73);
        const switchIdTop74T = this.findDeviceId(this.switchTitleTop74 + "温度");
        const switchIdTop74H = this.findDeviceId(this.switchTitleTop74 + "湿度");
        const switchIdTop74P = this.findDeviceId(this.switchTitleTop74 + "压力");
        const switchIdTop75F = this.findDeviceId(this.switchTitleTop75 + "风速");
        const switchIdTop75V = this.findDeviceId(this.switchTitleTop75 + "风量");
        const switchIdTop76T = this.findDeviceId(this.switchTitleTop76 + "温度");
        const switchIdTop76H = this.findDeviceId(this.switchTitleTop76 + "湿度");
        const switchIdTop76P = this.findDeviceId(this.switchTitleTop76 + "压力");
        const switchIdTop77F = this.findDeviceId(this.switchTitleTop77 + "风速");
        const switchIdTop77V = this.findDeviceId(this.switchTitleTop77 + "风量");
        const switchIdTop78T = this.findDeviceId(this.switchTitleTop78 + "温度");
        const switchIdTop78H = this.findDeviceId(this.switchTitleTop78 + "湿度");
        const switchIdTop78P = this.findDeviceId(this.switchTitleTop78 + "压力");
        const switchIdTop79F = this.findDeviceId(this.switchTitleTop79 + "风速");
        const switchIdTop79V = this.findDeviceId(this.switchTitleTop79 + "风量");
        const switchIdTop710T = this.findDeviceId(this.switchTitleTop710 + "温度");
        const switchIdTop710H = this.findDeviceId(this.switchTitleTop710 + "湿度");
        const switchIdTop710P = this.findDeviceId(this.switchTitleTop710 + "压力");
        const switchIdTop711F = this.findDeviceId(this.switchTitleTop711 + "风速");
        const switchIdTop711V = this.findDeviceId(this.switchTitleTop711 + "风量");
        const switchIdTop712T = this.findDeviceId(this.switchTitleTop712 + "温度");
        const switchIdTop712H = this.findDeviceId(this.switchTitleTop712 + "湿度");
        const switchIdTop712P = this.findDeviceId(this.switchTitleTop712 + "压力");
        const switchIdTop713F = this.findDeviceId(this.switchTitleTop713 + "风速");
        const switchIdTop713V = this.findDeviceId(this.switchTitleTop713 + "风量");
        const switchIdTop714T = this.findDeviceId(this.switchTitleTop714 + "温度");
        const switchIdTop714H = this.findDeviceId(this.switchTitleTop714 + "湿度");
        const switchIdTop714P = this.findDeviceId(this.switchTitleTop714 + "压力");
        const switchIdTop715F = this.findDeviceId(this.switchTitleTop715 + "风速");
        const switchIdTop715V = this.findDeviceId(this.switchTitleTop715 + "风量");

        this.switchDataTop71 = {
          data: currentData[switchIdTop71].value,
          isError: currentData[switchIdTop71].errorLevel,
          unit: "℃",
        };
        this.switchDataTop72 = {
          data: currentData[switchIdTop72].value,
          isError: currentData[switchIdTop72].errorLevel,
          unit: "%",
        };
        this.switchDataTop73 = {
          data: currentData[switchIdTop73].value,
          isError: currentData[switchIdTop73].errorLevel,
          unit: "KPa",
        };
        this.switchDataTop74 = [
          {
            data: currentData[switchIdTop74T].value,
            isError: currentData[switchIdTop74T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop74H].value,
            isError: currentData[switchIdTop74H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop74P].value,
            isError: currentData[switchIdTop74P].errorLevel,
            unit: "KPa",
          },
        ];
        this.switchDataTop75 = [
          {
            data: currentData[switchIdTop75F].value,
            isError: currentData[switchIdTop75F].errorLevel,
            unit: "m/s",
          },
          {
            data: currentData[switchIdTop75V].value,
            isError: currentData[switchIdTop75V].errorLevel,
            unit: "m³/h",
          },
        ];
        this.switchDataTop76 = [
          {
            data: currentData[switchIdTop76T].value,
            isError: currentData[switchIdTop76T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop76H].value,
            isError: currentData[switchIdTop76H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop76P].value,
            isError: currentData[switchIdTop76P].errorLevel,
            unit: "KPa",
          },
        ];
        this.switchDataTop77 = [
          {
            data: currentData[switchIdTop77F].value,
            isError: currentData[switchIdTop77F].errorLevel,
            unit: "m/s",
          },
          {
            data: currentData[switchIdTop77V].value,
            isError: currentData[switchIdTop77V].errorLevel,
            unit: "m³/h",
          },

        ];
        this.switchDataTop78 = [
          {
            data: currentData[switchIdTop78T].value,
            isError: currentData[switchIdTop78T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop78H].value,
            isError: currentData[switchIdTop78H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop78P].value,
            isError: currentData[switchIdTop78P].errorLevel,
            unit: "KPa",
          },
        ];
        this.switchDataTop79 = [
          {
            data: currentData[switchIdTop79F].value,
            isError: currentData[switchIdTop79F].errorLevel,
            unit: "m/s",
          },
          {
            data: currentData[switchIdTop79V].value,
            isError: currentData[switchIdTop79V].errorLevel,
            unit: "m³/h",
          },

        ];
        this.switchDataTop710 = [
          {
            data: currentData[switchIdTop710T].value,
            isError: currentData[switchIdTop710T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop710H].value,
            isError: currentData[switchIdTop710H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop710P].value,
            isError: currentData[switchIdTop710P].errorLevel,
            unit: "KPa",
          },
        ];
        this.switchDataTop711 = [
          {
            data: currentData[switchIdTop711F].value,
            isError: currentData[switchIdTop711F].errorLevel,
            unit: "m/s",
          },
          {
            data: currentData[switchIdTop711V].value,
            isError: currentData[switchIdTop711V].errorLevel,
            unit: "m³/h",
          },

        ];
        this.switchDataTop712 = [
          {
            data: currentData[switchIdTop712T].value,
            isError: currentData[switchIdTop712T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop712H].value,
            isError: currentData[switchIdTop712H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop712P].value,
            isError: currentData[switchIdTop712P].errorLevel,
            unit: "KPa",
          },
        ];
        this.switchDataTop713 = [
          {
            data: currentData[switchIdTop713F].value,
            isError: currentData[switchIdTop713F].errorLevel,
            unit: "m/s",
          },
          {
            data: currentData[switchIdTop713V].value,
            isError: currentData[switchIdTop713V].errorLevel,
            unit: "m³/h",
          },

        ];
        this.switchDataTop714 = [
          {
            data: currentData[switchIdTop714T].value,
            isError: currentData[switchIdTop714T].errorLevel,
            unit: "℃",
          },
          {
            data: currentData[switchIdTop714H].value,
            isError: currentData[switchIdTop714H].errorLevel,
            unit: "%",
          },
          {
            data: currentData[switchIdTop714P].value,
            isError: currentData[switchIdTop714P].errorLevel,
            unit: "KPa",
          },
        ];
        this.switchDataTop715 = [
          {
            data: currentData[switchIdTop715F].value,
            isError: currentData[switchIdTop715F].errorLevel,
            unit: "m/s",
          },
          {
            data: currentData[switchIdTop715V].value,
            isError: currentData[switchIdTop715V].errorLevel,
            unit: "m³/h",
          },

        ];

        const switchIdDown100 = this.findDeviceId(this.switchTitleDown100);
        const switchIdDown101A = this.findDeviceId(this.switchTitleDown101.replace("状态", "运行"));
        const switchIdDown101B = this.findDeviceId(this.switchTitleDown101.replace("状态", "故障"));
        const switchIdDown11A = this.findDeviceId(this.switchTitleDown11.replace("开关", "开"));
        const switchIdDown11B = this.findDeviceId(this.switchTitleDown11.replace("开关", "关"));
        const switchIdDown12 = this.findDeviceId(this.switchTitleDown12);
        const switchIdDown13 = this.findDeviceId(this.switchTitleDown13.replace("状态", ""));
        const switchIdDown14 = this.findDeviceId(this.switchTitleDown14);
        const switchIdDown15 = this.findDeviceId(this.switchTitleDown15);
        const switchIdDown16 = this.findDeviceId(this.switchTitleDown16);
        const switchIdDown17 = this.findDeviceId(this.switchTitleDown17);
        
        this.switchDataDown100 = {
          data: currentData[switchIdDown100].enumValue,
          isError: currentData[switchIdDown100].errorLevel,
        };
        this.switchDataDown101 = [
          {
            data: currentData[switchIdDown101A].value,
            isError: currentData[switchIdDown101A].errorLevel,
          },
          {
            data: currentData[switchIdDown101B].value,
            isError: currentData[switchIdDown101B].errorLevel,
            isZh: true,
          },
        ];
        this.switchDataDown11 = [
          {
            data: currentData[switchIdDown11A].value,
            isError: currentData[switchIdDown11A].errorLevel,
            textOff: "正常",
            textOn: "开机",
          },
          {
            data: currentData[switchIdDown11B].value,
            isError: currentData[switchIdDown11B].errorLevel,
            textOff: "正常",
            textOn: "关机"
          },
        ];
        this.switchDataDown12 = {
          data: currentData[switchIdDown12].value,
          isError: currentData[switchIdDown12].errorLevel,
        };
        this.switchDataDown13 = {
          data: currentData[switchIdDown13].value,
          isError: currentData[switchIdDown13].errorLevel,
        };
        this.switchDataDown14 = {
          data: currentData[switchIdDown14].value,
          isError: currentData[switchIdDown14].errorLevel,
          isZh: true,
        };
        this.switchDataDown15 = {
          data: currentData[switchIdDown15].value,
          isError: currentData[switchIdDown15].errorLevel,
          isZh: true,
        };
        this.switchDataDown16 = {
          data: currentData[switchIdDown16].value,
          isError: currentData[switchIdDown16].errorLevel,
          isZh: true,
        };
        this.switchDataDown17 = {
          data: currentData[switchIdDown17].value,
          isError: currentData[switchIdDown17].errorLevel,
        };

        // const runningTimeIdLeft = this.findDeviceId(this.runningTimeTitleLeft);
        // this.runningTimeDataLeft = currentData[runningTimeIdLeft].value;

        // const runningTimeIdRight = this.findDeviceId(this.runningTimeTitleRight);
        // this.runningTimeDataRight = currentData[runningTimeIdRight].value;
      });
    },

    setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getLineChartData() {
      let temperatureDeviceName = "除湿机温度";
      let humidityDeviceName = "除湿机湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineData", "warningFlagLeft");
          })
        );
    },
    setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>
    
    <style lang="scss" scoped>
.dehumidifier-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  padding-bottom: 10px;

  // & div {
  //   border: 1px solid;
  // }

  .dehumidifier-main {
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: stretch;
    align-content: space-between;
  }

  .column-line {
    width: 100%;
    height: calc(50% - 10px);

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column {
    width: calc(100% / 7 - 15px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column-small {
    width: calc(100% / 7 - 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column-large {
    width: calc(100% / 7 + 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column-multi-line {
    width: calc(100% / 7 - 10px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .switch-item-title {
    height: 38px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;
    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item {
    height: 33px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;
    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }
}
</style>
    